class TdPlanSelectorForm extends HTMLElement {
  constructor() {
    super();

    this.HIDDEN_CLASS = 'td-hidden';
    this.DISABLED_CLASS = 'td-disabled';

    this.TOOL_TIP_TRIGGERS = this.querySelectorAll("[data-td-tip-trigger]");
    this.TOOL_TIP_CONTENT = this.querySelector("[data-td-tip-content]");

    this.GIFTING_RADIOS = this.querySelectorAll("[data-td-gift-radio]");
    this.GIFTING_INFO_WRAPPER = this.querySelector("[data-td-gift-info]");
    this.GIFTING_INPUTS = this.querySelectorAll("[data-td-gift-input]");
    this.GIFT_INPUT_ERROR = this.querySelector(".__td-label-error");

    this.SUBMIT_BUTTON = this.querySelector("[data-td-product-submit]");
    this.FORM_ELEMENT = this.querySelector(".shopify-product-form");

    this.PLAN_SELECTOR_RADIOS = this.querySelectorAll("[data-plan-name]");

    this.ATC_PRICE_ELMS = this.querySelectorAll("[data-td-atc-price]");
    this.SELECTED_PLAN_TEXT = this.querySelector("[data-td-slected-plan-text]");

    this.BENEFITS_ELMS = this.querySelectorAll("[data-plan-id]")

  }

  connectedCallback() {
    this.attachListeners();
  }

  attachListeners() {
    if (this.TOOL_TIP_CONTENT) {
      this.TOOL_TIP_TRIGGERS.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          this.toggleToolTip(trigger.dataset.tdTipTrigger);
        });
      });
      document.addEventListener('click', (event) => {
        if (!this.TOOL_TIP_CONTENT.classList.contains(this.HIDDEN_CLASS) && !event.target.closest('.td-plan-selector__tip')) {
          this.TOOL_TIP_CONTENT.classList.add(this.HIDDEN_CLASS);
        }
      });
    }
    if (this.GIFTING_INFO_WRAPPER) {
      this.GIFTING_RADIOS.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.toggleGiftInputs(radio);
          this.toggleSellingPlans(radio);
        });
      });
    }
    if (this.SUBMIT_BUTTON && this.FORM_ELEMENT) {
      this.SUBMIT_BUTTON.addEventListener("click", this.validateForm.bind(this));
    }

    this.PLAN_SELECTOR_RADIOS.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.handleAtcPrice(radio);
        this.handleLabelText(radio);
        this.handleBenefitsText(radio);
      });
    });
    window.addEventListener('load', (event) => {
      this.PLAN_SELECTOR_RADIOS.forEach((radio) => {
        if (radio.checked) {
          this.handleAtcPrice(radio);
          this.handleLabelText(radio);
          this.handleBenefitsText(radio);
        }
      });
    });
  }

  toggleToolTip(action) {
    if (action === 'open') {
      this.TOOL_TIP_CONTENT.classList.remove(this.HIDDEN_CLASS);
    } else if (action === 'close') {
      this.TOOL_TIP_CONTENT.classList.add(this.HIDDEN_CLASS);
    }
  }

  toggleGiftInputs(radio) {
    if (radio.id === 'subscriptionNoGift') {
      this.GIFTING_INFO_WRAPPER.classList.add(this.HIDDEN_CLASS);
      this.SUBMIT_BUTTON.classList.remove(this.DISABLED_CLASS);
      this.GIFTING_INPUTS.forEach((input) => {
        input.disabled = true;
      });
    } else if (radio.id === 'subscriptionGift') {
      this.GIFTING_INFO_WRAPPER.classList.remove(this.HIDDEN_CLASS);
      this.GIFTING_INPUTS.forEach((input) => {
        input.disabled = false;

        let timeoutId;
        input.addEventListener('input', () => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            this.validateForm();
          }, 500);
        });
      });
      this.validateForm();
    }
  }

  toggleSellingPlans(radio) {
    if (radio.id === 'subscriptionGift') {
      let flg = 0;
      this.PLAN_SELECTOR_RADIOS.forEach((radio) => {
        if (!radio.dataset.planName.includes('(Prepaid)')) {
          radio.checked = false;
          let parentLabel = radio.closest('.td-plan-selector__radio');
          if (parentLabel) {
            parentLabel.classList.add(this.HIDDEN_CLASS);
          }
        } else if (radio.dataset.planName.includes('(Prepaid)') && flg === 0) {
          flg++;        
          radio.checked = true;
          radio.dispatchEvent(new Event('change'));
        }
      });
    } else if (radio.id === 'subscriptionNoGift') {
      this.PLAN_SELECTOR_RADIOS.forEach((radio) => {
        if (!radio.dataset.planName.includes('(Prepaid)')) {
          let parentLabel = radio.closest('.td-plan-selector__radio');
          if (parentLabel) {
            parentLabel.classList.remove(this.HIDDEN_CLASS);
          }
        }
      });
    }
  }

  validateForm(event) {
    this.SUBMIT_BUTTON.classList.add(this.DISABLED_CLASS);

    let isValidFlag = 0;
    this.GIFTING_INPUTS.forEach((input) => {
      if (this.validateIndividualField(input)) {
        isValidFlag++;
      }
    });

    if (isValidFlag >= this.GIFTING_INPUTS.length) {
      if (this.GIFT_INPUT_ERROR) {
        this.GIFT_INPUT_ERROR.classList.add(this.HIDDEN_CLASS);
      }
      this.SUBMIT_BUTTON.classList.remove(this.DISABLED_CLASS);
    } else {
      this.GIFT_INPUT_ERROR.classList.remove(this.HIDDEN_CLASS);
    }
  }



  validateIndividualField(field) {
    if (field.type === 'text' || field.type === 'textarea') {
      if (field.value === '') {
        return false;
      }
      return true;
    } else if (field.type === 'email') {
      if (field.value.trim() === '') {
        return false;
      }
      const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
      if (!emailPattern.test(field.value)) {
        return false;
      }
      return true;
    } else if (field.type === 'select-one') {
      if (field.value.trim() === '') {
        return false;
      }
      return true;
    } else if (field.type === 'tel') {
      if (field.value === '') {
        return false;
      }
      return true;
    }
  }

  handleAtcPrice(radio) {
    let atcPrice = radio.dataset.atcPlanInfo;
    if (atcPrice) {
      this.ATC_PRICE_ELMS.forEach((elm) => {
        elm.innerHTML = atcPrice;
      });
    }
  }

  handleBenefitsText(radio) {
    const radioId = radio.value
    if (this.BENEFITS_ELMS) {
      this.BENEFITS_ELMS.forEach((elm) => {
        elm.classList.remove("td-plan-selector__benefits-open");
        const benefitId = elm.getAttribute("data-plan-id")
        if (benefitId) {
          if (radioId == benefitId) {
            elm.classList.add("td-plan-selector__benefits-open")
          }
        }
      })
    }
  }

  handleLabelText(radio) {
    let labelText = radio.dataset.planName;
    if (labelText && this.SELECTED_PLAN_TEXT) {
      this.SELECTED_PLAN_TEXT .innerHTML = labelText;
    }
  }
}
if (!customElements.get("td-plan-selector-form")) {
  customElements.define("td-plan-selector-form", TdPlanSelectorForm);
}
